import React, { RefObject, FC, ReactNode} from "react"
import { goToValue } from "../../types"
import { SliderHandle } from "./Slider"

export interface ControlProps extends React.HTMLAttributes<HTMLButtonElement> {
    slider?: RefObject<SliderHandle> | null
    goTo: goToValue
    disabled?:boolean
    className?: string
    children?: ReactNode
    validate?: (nextValue: goToValue) => boolean
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

export const Control: FC<ControlProps> = ({
    children, 
    slider = null, 
    className = '', 
    disabled,
    goTo, 
    validate = () => true, 
    onClick = () => {}, 
    ...rest
}) => {

    return (
        <button 
            aria-hidden
            tabIndex={-1}
            disabled={disabled}
            className={`control ${className}`} 
            onClick={(e) => {
                if (!slider) return
                if (!slider.current) return

                const ableToGo = validate(goTo)
                if (ableToGo && slider) slider.current.goTo(goTo)
                onClick(e)
            }}
            {...rest}
        >
            {children}
        </button>
    )
}